<div id="question-modal">
  <div class="container-fluid modal-style">
    <div class="modal-header">
      <span class="close-btn" (click)="close()">
        <img src="assets/icons/close.svg" />
      </span>
    </div>
    <div class="modal-body">
      <p *ngIf="showWarningIcon" class="warning-icon">⚠️</p>
      <p class="modal-title text-style">{{ header }}</p>
      <p class="modal-content text-style">{{ text }}</p>
    </div>
    <div class="modal-footer button-area">
      <p-button class="button-style no" severity="secondary" (click)="cancel()">
        {{ 'general.no' | translate }}
      </p-button>

      <p-button class="button-style" severity="primary" (click)="ok()">
        {{ 'general.yes' | translate }}
      </p-button>
    </div>
  </div>
</div>
